import BaseManager from "@base/baseManager.js";
import api from "@api/api.js";
import GalleryObject from "./galleryObject.js";

/**
 * Gallery data: fetches the overview from the backend and stores GalleryObjects.
 * Also tracks whether the current user is an admin (returned by the overview).
 */
export default class GalleryManager extends BaseManager {
  constructor() {
    super("galleryId");
    this.admin = false;
    this.heroImage = null;
  }

  async load() {
    const [overview, settings] = await Promise.all([
      api.get("/api/get/galleryOverview"),
      api.get("/api/settings").catch(() => null),
    ]);
    this.admin = Boolean(overview?.admin);
    this.heroImage = settings?.heroImage ?? null;
    this.set((overview?.galleries || []).map((g) => new GalleryObject(g)));
    return this.all();
  }
}
